import * as React from "react";
import { db } from "../../firebase";
import { withAuthorization } from "../../firebase/withAuthorization";
import { Header, Image, Modal, Button, Icon} from 'semantic-ui-react'
import { GifList } from "../../pills/gifs/gifList";
import { GifUpdateForm } from "../../pills/gifs/gifUpdateForm";



class UserDetailsComponent extends React.Component {

  constructor(props: any) {
    super(props);

    this.state = {
      userGifs: null,
      userGifsIds : [],
      user: null,
      tags: null,
      currentGif: null,
      modalUpdateOpen: false,
      modalDeleteOpen: false };

        this.handleOpenUpdateModal = this.handleOpenUpdateModal.bind(this)
        this.handleOpenDeleteModal = this.handleOpenDeleteModal.bind(this)
        this.handleCloseUpdateModal = this.handleCloseUpdateModal.bind(this)
        this.handleGifUpdated = this.handleGifUpdated.bind(this)
    }

    componentDidMount() {
        const id = window.location.pathname.split('/')[2]
        db.getUserById(id).then(snapshot =>
        {  const user = snapshot.val()
          user.id = id ;
          this.setState(() => ({ user: user }))
        });
        db.getUserGifsIds(id).then(snapshot => {
            const gifsIds = snapshot.val() ? Object.keys(snapshot.val()) : []
            this.setState(() => ({ userGifsIds: gifsIds }))
            const promises  = gifsIds.map(async key => {
                const response = await db.getGifById(key).then(snapshot => {
                    return snapshot.val()
                })
                return response
            })

            // Wait for all Promises to complete
            Promise.all(promises)
            .then(results => {
                this.setState(() => ({ userGifs: results }))
            })
            .catch(e => {
                console.error(e);
            })
        })
        .catch(error => {
            console.log(error)
        });   

        db.onceGetTags().then(snapshot =>
        this.setState(() => ({ tags: snapshot.val() }))
        );
    }

    handleCloseUpdateModal(){
    this.setState(() => ({ 
      modalUpdateOpen: false,
      }))
    }

    handleOpenUpdateModal(gif : any){
    this.setState(() => ({ 
      modalUpdateOpen: true,
      currentGif: gif
      }))
    }

    handleOpenDeleteModal(gif : any){
    this.setState(() => ({ 
      modalDeleteOpen: true,
      currentGif: gif
      }))
    }
      
    handleGifUpdated() {
            const { userGifsIds }: any = this.state;

            const promises  = userGifsIds.map(async key => {
                const response = await db.getGifById(key).then(snapshot => {
                    return snapshot.val()
                })
                return response
            })

            // Wait for all Promises to complete
            Promise.all(promises)
            .then(results => {
                this.setState(() => ({ userGifs: results ,  modalUpdateOpen: false}))
            })
            .catch(e => {
                console.error(e);
            })
    }

    handleDeleteClose = () => this.setState({ modalDeleteOpen: false })

    onDelete(gif) {
    const { userGifsIds }: any = this.state;

      db.doDeleteGif(gif.id).then(() =>
      { 
        console.log("Category Deleted")
            const promises  = userGifsIds.map(async key => {
                const response = await db.getGifById(key).then(snapshot => {
                    return snapshot.val()
                })
                return response
            })

            // Wait for all Promises to complete
            Promise.all(promises)
            .then(results => {
                this.setState(() => ({ userGifs: results ,  modalDeleteOpen: false}))
            })
            .catch(e => {
                console.error(e);
            })
        });
  }



   render() {
    const { user, userGifs , tags, currentGif , modalDeleteOpen, modalUpdateOpen  }: any = this.state;
    return (
        <div>
        { !!user &&
            <div>
                <Header as='h1' block>
                    <Image circular src={user.photo} />
                    <Header.Content>
                        {user.name}
                        <Header.Subheader>{user.email}</Header.Subheader>
                    </Header.Content>
                </Header>
                <Modal 
                    open={modalUpdateOpen} >
                    <Modal.Header>Update Gif</Modal.Header>
                    <Modal.Content>
                        <GifUpdateForm onGifUpdated={this.handleGifUpdated} handleCloseModal={this.handleCloseUpdateModal} currentGif= {currentGif} tags={tags}  />
                    </Modal.Content> 
                </Modal>
                <Modal 
                    open={modalDeleteOpen} >
                    <Modal.Header>Delete Gif</Modal.Header>
                        <Modal.Content>
                        Are you sure you want to delete this Gif?
                        </Modal.Content>
                        <Modal.Actions>
                        <Button color='green'  onClick={this.handleDeleteClose}>
                            <Icon name='remove'  /> No
                        </Button>
                        <Button color='red' onClick={() => this.onDelete(currentGif)} >
                            <Icon name='checkmark'/> Yes
                        </Button>
                    </Modal.Actions>
                </Modal>
                 {!!userGifs && <GifList handleDelete={this.handleOpenDeleteModal} handleUpdate={this.handleOpenUpdateModal} gifs={userGifs} />}
            </div>
        }
        </div>
    )
  }
}

const authCondition = (authUser: any) => !!authUser ;

export const UserDetailsPage = withAuthorization(authCondition)(UserDetailsComponent);


// WEBPACK FOOTER //
// ./src/pages/userDetails/index.tsx